import React, {useCallback, useEffect, useMemo, useState} from "react";
import Modal from 'react-modal';
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as fas from "@fortawesome/pro-solid-svg-icons";
import {darkGreen, lightGreen} from "../Components/BaseComponents";

const StyledModal = styled(Modal)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  z-index: 10000;
  border: 1px solid black;
  outline: none;
  overflow: auto;
  max-height: 95vh;
  max-width: 95vw;
`;

const HeaderWrapper = styled.div`
  background: ${darkGreen};
  color: white;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 5px;
  right: 10px;
  color: ${lightGreen};
  cursor: pointer;
  font-size: 18px;
  z-index: 10002;

  &:hover {
    color: white;
  }
`;

export const useModal = () => {
    const [isOpen, setIsOpen] = useState();
    const [header, setHeader] = useState();
    const [content, setContent] = useState();

    useEffect(() => {
        const onKeyup = e => {
            if (e.key === 'Escape') {
                setIsOpen(false);
            }
        };
        window.addEventListener('keyup', onKeyup);
        return () => window.removeEventListener('keyup', onKeyup);
    }, []);

    const openModal = useCallback(({header, content}) => {
        setHeader(header);
        setContent(content);
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => setIsOpen(false), []);

    const modalComponent = useMemo(() => (
        <StyledModal
            ariaHideApp={false} //See: https://stackoverflow.com/a/50625073/5515589
            style={{overlay: {zIndex: 10000}}}
            isOpen={isOpen}
        >
            <CloseButton onClick={closeModal}>
                <FontAwesomeIcon icon={fas.faTimes}/>
            </CloseButton>
            <HeaderWrapper>
                {header}
            </HeaderWrapper>
            <div style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                {content}
            </div>
        </StyledModal>
    ), [isOpen, content]);

    return {modalComponent, openModal, closeModal};
};